/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import ContainerHome24 from '../../atoms/ContainerHome24';
import WhiteButton from '../../atoms/WhiteButton/WhiteButton';
import Styles from './Home24HeroF1.css';
import RedButton from '@/components/atoms/RedButton';

function Home24HeroF1() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="hero-santander-financiamentos">
        <ContainerHome24>
          <div className="hero-img">
            {typeof window === 'undefined' ? (
              <></>
            ) : (
              <>
                {width <= 599 && (
                  <img
                    src="assets/home24/hero-f1/img-280.png"
                    alt="Banner promocional do Santander e Fórmula 1 com imagem de um veículo de corrida, divulgando financiamento de motos e carros e a oportunidade de concorrer a uma experiência exclusiva."
                    className=""
                  />
                )}
                {width > 599 && width <= 799 && (
                  <img
                    src="assets/home24/hero-f1/img-240.png"
                    alt="Banner promocional do Santander e Fórmula 1 com imagem de um veículo de corrida, divulgando financiamento de motos e carros e a oportunidade de concorrer a uma experiência exclusiva."
                    className=""
                  />
                )}
                {width > 799 && width <= 1099 && (
                  <img
                    src="assets/home24/hero-f1/img-379.png"
                    alt="Banner promocional do Santander e Fórmula 1 com imagem de um veículo de corrida, divulgando financiamento de motos e carros e a oportunidade de concorrer a uma experiência exclusiva."
                    className=""
                  />
                )}
                {width > 1099 && (
                  <img
                    src="assets/home24/hero-f1/img-572.png"
                    alt="Banner promocional do Santander e Fórmula 1 com imagem de um veículo de corrida, divulgando financiamento de motos e carros e a oportunidade de concorrer a uma experiência exclusiva."
                    className=""
                  />
                )}
              </>
            )}
          </div>
          <div className="hero-contain">
            {/* <div className="hero-selo">
                <img src="assets/mes-do-ambiente/home/img-selo.svg" alt="" className="" />
              </div> */}
            <div className="hero-texts">
              <h1 className="hero-title">Seu próximo veículo pode levar você a FÓRMULA 1</h1>
              <h2 className="hero-sub-title">
                Financie seu carro ou moto com o Santander e concorra a uma experiência exclusiva no
                GP da Inglaterra.
              </h2>
            </div>
            <div className="hero-buttons">
              <WhiteButton
                href="https://www.cliente.santanderfinanciamentos.com.br/originacaocliente/?int_source=portalSF&int_medium=hero-banner-home-partiu-gp-da-inglaterra&int_campaign=simular#/dados-pessoais"
                id="hero-button-simular-financiamento"
                wide
                target="_blank"
              >
                Simular
              </WhiteButton>
              {/* <RedButton href="#santander-carousel" id="hero-button-outros-produtos">
                Outros produtos
              </RedButton> */}
            </div>
          </div>
        </ContainerHome24>
        <style jsx>{Styles}</style>
      </section>
    </>
  );
}

export default Home24HeroF1;
